
        var result = require("!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../postcss-loader/dist/cjs.js!./style.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    